/* eslint-disable jsx-a11y/label-has-for */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MananaSlider from '../../../_utils/manana-slider';
import SliderScale, { NUMBER_OF_TICKS } from './slider-scale';

const SliderControl = props => {
  const {
    id,
    label,
    disabled,
    onChange,
    value,
    threshold,
    min,
    max,
    className,
    sliderRef,
    hideLabel,
  } = props;
  const step = (max - min) / (NUMBER_OF_TICKS * 4); // Ensure input steps are smaller than the markers for smoother movement

  return (
    <div className={classNames('slider-control', className)}>
      <label className={classNames({ 'sr-only': hideLabel })} htmlFor={id}>
        {label}
      </label>
      <div
        className={classNames('slider-control__wrapper', {
          disabled: disabled,
        })}>
        <MananaSlider
          ref={sliderRef}
          id={id}
          classNames
          disabled={disabled}
          label={label}
          min={min}
          max={max}
          step={step}
          value={value}
          handleChange={onChange}
          threshold={threshold}
        />

        <SliderScale />
      </div>
    </div>
  );
};

SliderControl.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.number.isRequired,
  threshold: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  sliderRef: PropTypes.func,
  hideLabel: PropTypes.bool,
};

SliderControl.defaultProps = {
  disabled: false,
  hideLabel: false,
  threshold: undefined,
  min: 0,
  max: 100,
  onChange: () => {},
  className: null,
  sliderRef: () => {},
  label: '',
};

export default SliderControl;
